/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module VsLogsModule
 */

import { IConnectionLog } from 'generated-types';
import { Pipe, PipeTransform } from '@angular/core';

interface IL4ClientInfo extends Pick<IConnectionLog, 'client_location'> {
    startTime?: IConnectionLog['start_timestamp'];
    endTime?: IConnectionLog['report_timestamp'];
}

/* eslint-disable @typescript-eslint/naming-convention */
/**
 * @description
 *     Pipe for extracting L4 client info from an L4 log.
 * @author Zhiqian Liu
 */
@Pipe({
    name: 'l4ClientInfo',
})
export class L4ClientInfoPipe implements PipeTransform {
    /** @override */
    // eslint-disable-next-line class-methods-use-this
    public transform(log: IConnectionLog): IL4ClientInfo {
        if (!log) {
            return {};
        }

        const {
            client_location,
            report_timestamp,
            start_timestamp,
        } = log;

        return {
            client_location,
            endTime: report_timestamp,
            startTime: start_timestamp,
        };
    }
}
